import * as React from 'react';

const NoEmployeeIcon = (props) => (
  <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="40.5" cy="40" r="40" fill="#F9FAFB" />
    <g clipPath="url(#clip0_19185_259913)">
      <circle cx="41" cy="40" r="22" fill="#9B8AFC" />
      <ellipse cx="40.9997" cy="67.7191" rx="23.32" ry="20.68" fill="#344054" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9729 60.4896C26.7 56.614 22.52 49.6752 22.52 41.76C22.52 29.6097 32.3697 19.76 44.52 19.76C47.3526 19.76 50.0602 20.2953 52.5471 21.2704C49.1907 19.1967 45.2351 18 41 18C28.8497 18 19 27.8497 19 40C19 49.3176 24.7925 57.2824 32.9729 60.4896Z"
        fill="white"
        fillOpacity="0.6"
      />
      <circle cx="41.0003" cy="35.5999" r="9.68" fill="#FFCCB3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9455 44.3923C34.7766 42.6172 33.3923 39.919 33.3923 36.8976C33.3923 31.5515 37.7262 27.2176 43.0723 27.2176C44.5201 27.2176 45.8937 27.5354 47.127 28.1052C45.4583 26.7394 43.325 25.9199 41.0003 25.9199C35.6542 25.9199 31.3203 30.2538 31.3203 35.5999C31.3203 39.4982 33.6247 42.8583 36.9455 44.3923Z"
        fill="#FFE2D3"
      />
    </g>
    <path d="M60.7839 18.3887L22.5371 61.3904" stroke="#F97066" strokeWidth="1.76" strokeLinecap="round" />
    <defs>
      <clipPath id="clip0_19185_259913">
        <rect x="19" y="18" width="44" height="44" rx="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NoEmployeeIcon;
